import React from "react";

const Social = () => {
  return (
    <div className="home_social">
      <a
        href="https://github.com/itsvee0120"
        className="home_social-icon"
        target="blank"
      >
        <i className="uil uil-github-alt"></i>
      </a>

      <a
        href="https://www.linkedin.com/in/violetnguyen0120/"
        className="home_social-icon"
        target="blank"
      >
        <i class="uil uil-linkedin-alt"></i>
      </a>
    </div>
  );
};

export default Social;
